<template>
  <div :class="$vuetify.breakpoint.xsOnly ? 'mb-10' : ''">
    <div v-if="!$vuetify.breakpoint.xsOnly" class="">
      <div class="d-flex align-center mb-4">
        <div>
          <v-btn @click="$router.push('main')" class="left-arrow" icon>
            <v-icon>mdi-arrow-top-left</v-icon>
          </v-btn>
        </div>
        <div class="ml-2">
          <span class="market-header">Premium Groups</span>
        </div>
      </div>
      <v-row>
        <v-col
          style=""
          v-for="(item, i) in premium_groups"
          :key="i.id"
          class=""
          cols="12"
          sm="12"
          md="4"
        >
          <v-card min-height="335px" style="border-radius: 12px">
            <v-card-title
              v-if="item.is_limited_offer"
              class="title justify-center"
            >
              <div class="title-txt">
                Limited Time Offer
                <span class="ml-2"> {{ item.is_limited_offer }} </span>
              </div>
            </v-card-title>
            <v-card-text class="px-0 pt-0">
              <div style="position: relative">
                <v-img
                  :height="item.is_limited_offer ? '72px' : '104px'"
                  :src="item.cover_image ? item.cover_image : group_cover"
                  :class="!item.is_limited_offer ? 'br-radius' : ''"
                >
                </v-img>
                <div class="user-abs">
                  <div v-if="item.picture == null" class="user-name">
                    <div>{{ getName(item.name) }}</div>
                  </div>
                  <v-img v-else class="user-image" :src="item.picture"> </v-img>
                </div>
              </div>
              <div class="user-badge d-flex justify-end align-center">
                <div class="sebi-ria mr-2">
                  <div v-if="item.admin_payment_info" class="">
                    SEBI
                    {{
                      getSebi(item.admin_payment_info.profile.sebi_user_type)
                    }}
                  </div>
                </div>
                <div>
                  <v-img class="user-img-badge" :src="premium_badge"> </v-img>
                </div>
              </div>
            </v-card-text>
            <v-card-text class="px-3 pt-0 pb-2">
              <div>
                <div class="group-header">{{ item.name }}</div>
                <div v-if="item.admin" class="group-subheader">
                  By {{ item.admin.profile.name }}
                </div>
              </div>
              <div
                :style="
                  !item.types_of_instrument.length ? 'margin-top: 35px' : ''
                "
                class="d-flex pb-1 dashed-border"
              >
                <v-chip-group
                  v-for="(inst, i) in item.types_of_instrument"
                  :key="i.id"
                  multiple
                  class="px-0"
                  mandatory
                >
                  <v-chip
                    class="px-1 py-2"
                    x-small
                    active
                    :color="getColor(i)"
                    label
                    outlined
                  >
                    <span class="intru-txt"> {{ inst }} </span>
                  </v-chip>
                </v-chip-group>
              </div>
              <div class="d-flex mt-4 dashed-border pb-3 justify-space-between">
                <div class="details">
                  <div v-if="item.metrics.closed_trades">
                    {{ item.metrics.closed_trades }}
                  </div>
                  <div v-else>-</div>
                  <div>Avg. Trades</div>
                </div>
                <div class="details">
                  <div v-if="item.metrics.accuracy">
                    {{ item.metrics.accuracy }}%
                  </div>
                  <div v-else>-</div>
                  <div>Accuracy</div>
                </div>
                <div class="details">
                  <div v-if="item.metrics.avg_trade_return">
                    {{ item.metrics.avg_trade_return }}%
                  </div>
                  <div v-else>-</div>
                  <div>Avg. Returns</div>
                </div>
              </div>
            </v-card-text>
            <v-card-actions
              :style="
                !item.price[0].is_discount_price_live ||
                btn_text(item) == 'View Group'
                  ? 'margin-top: 10px;'
                  : ''
              "
              class="pt-0 justify-space-between align-end"
            >
              <div
                v-if="item.price"
                :style="btn_text(item) == 'View Group' ? 'display: none' : ''"
              >
                <div v-if="item.price[0].is_discount_price_live">
                  <span class="discount-strike"
                    >₹ {{ item.price[0].price }} </span
                  ><span class="discount-percent ml-1">
                    {{ item.price[0].discount_percentage.toFixed(2) }}% OFF
                  </span>
                </div>
                <div
                  v-if="item.price[0].is_discount_price_live"
                  class="discount-price"
                >
                  ₹ {{ item.price[0].discount_price }}/{{
                    item.price[0].plan.slice(0, -2)
                  }}
                </div>
                <div v-else class="discount-price">
                  ₹ {{ item.price[0].price }}/{{
                    item.price[0].plan.slice(0, -2)
                  }}
                </div>
              </div>
              <!-- <div></div> -->
              <div :style="btn_text(item) == 'View Group' ? 'width: 100%' : ''">
                <v-btn
                  @click="viewGroup(item.id)"
                  class="text-capitalize subscribe"
                  height="30px"
                  color="primary"
                  :block="btn_text(item) == 'View Group'"
                >
                  {{ btn_text(item) }}
                </v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <v-card
        class="my-3"
        v-for="(item, i) in premium_groups"
        :key="i.id"
        height="167px"
        @click="viewGroup(item.id)"
      >
        <v-card-text class="pa-0">
          <div class="d-flex">
            <div>
              <div v-if="!item.picture" class="user-name">
                <div>{{ getName(item.name) }}</div>
              </div>
              <v-img v-else class="user-image" :src="item.picture"> </v-img>
              <div class="sebi-ra-mobile">
                <div class="">
                  SEBI
                  {{ getSebi(item.admin_payment_info.profile.sebi_user_type) }}
                </div>
              </div>
            </div>
            <div class="pa-3 pr-2" style="width: 100%">
              <div>
                <div class="d-flex align-center justify-space-between">
                  <div class="group-header">{{ item.name }}</div>
                  <div>
                    <v-img class="user-img-badge" :src="premium_badge"> </v-img>
                  </div>
                </div>
                <div v-if="item.admin" class="group-subheader mt-1">
                  By {{ item.admin.profile.name }}
                </div>
              </div>
              <div
                :style="
                  !item.types_of_instrument.length ? 'margin-top: 33px' : ''
                "
                class="d-flex"
              >
                <v-chip-group
                  v-for="(inst, i) in item.types_of_instrument"
                  :key="i.id"
                  multiple
                  class="px-0"
                  mandatory
                >
                  <v-chip
                    class="px-1 py-2"
                    x-small
                    active
                    :color="getColor(i)"
                    label
                    outlined
                  >
                    <span class="intru-txt"> {{ inst }} </span>
                  </v-chip>
                </v-chip-group>
              </div>
              <div
                :class="
                  btn_text(item) != 'View Group' ? 'dashed-border' : 'mt-6'
                "
                class="d-flex pb-3 justify-space-between"
              >
                <div class="details">
                  <div v-if="item.metrics.closed_trades">
                    {{ item.metrics.closed_trades }}
                  </div>
                  <div v-else>-</div>
                  <div>Avg. Trades</div>
                </div>
                <div class="details">
                  <div v-if="item.metrics.accuracy">
                    {{ item.metrics.accuracy }}%
                  </div>
                  <div v-else>-</div>
                  <div>Accuracy</div>
                </div>
                <div class="details">
                  <div v-if="item.metrics.avg_trade_return">
                    {{ item.metrics.avg_trade_return }}%
                  </div>
                  <div v-else>-</div>
                  <div>Avg. Returns</div>
                </div>
              </div>
              <div
                class="mt-1"
                v-if="item.price && btn_text(item) != 'View Group'"
              >
                <span
                  v-if="item.price[0].is_discount_price_live"
                  class="discount-price"
                >
                  ₹ {{ item.price[0].discount_price }}/{{
                    item.price[0].plan.slice(0, -2)
                  }}
                </span>
                <span v-else class="discount-price">
                  ₹ {{ item.price[0].price }}/{{
                    item.price[0].plan.slice(0, -2)
                  }}
                </span>
                <span v-if="item.price[0].is_discount_price_live">
                  <span class="discount-strike"
                    >₹ {{ item.price[0].price }} </span
                  ><span class="discount-percent ml-1"
                    >{{ item.price[0].discount_percentage.toFixed(2) }}% OFF
                  </span>
                </span>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import Axios from "@/api/BaseAxios.js";
// import newAxios from "@/api/newAxios";

export default {
  // props: {
  //   groups: {
  //     type: Array,
  //     required: true,
  //   },
  // },
  data() {
    return {
      premium_groups: [],
      kpiData: {},
      kpi_data_loading: false,
      group_cover: require("@/assets/images/group_cover_image.svg"),
      default_user: require("@/assets/images/default_user_photo.png"),
      premium_badge: require("@/assets/images/premium_badge.svg"),
    };
  },
  mounted() {
    this.getPremiumGroups();
    // this.getKpis();
  },
  computed: {
    // btn_text() {
    //   return this.groups.is_participant ? "View Group" : "Subscribe";
    // },
  },
  methods: {
    btn_text(item) {
      return item.is_participant || item.is_admin ? "View Group" : "Subscribe";
    },
    getColor(i) {
      const colorMap = ["#459393", "#3F7BC3", "#DD9324"];
      return colorMap[i] || "#333333CC"; // Fallback color
    },
    getName(grname) {
      let name = grname;
      name = name.split(" ");
      if (name[1]) {
        return (
          name[0].slice(0, 1).toUpperCase() + name[1].slice(0, 1).toUpperCase()
        );
      }
      return name[0].slice(0, 1).toUpperCase();
    },
    viewGroup(id) {
      this.$router.push({
        name: "premiumGroup",
        params: {
          id: id,
        },
      });
    },
    getSebi(item) {
      if (item == "registered_analyst") {
        return "RA";
      } else {
        return "RIA";
      }
    },
    // getKpis() {
    //   console.log(id);
    //   this.kpi_data_loading = true;
    //   const onSuccess = (res) => {
    //     this.kpiData = res.data.result;
    //     this.kpi_data_loading = false;
    //   };
    //   const onFailure = () => {
    //     this.kpi_data_loading = false;
    //   };
    //   let params = {};
    //   // params["group_id"] = this.premium_groups.id;
    //   params["filters"] = "ALL";
    //   newAxios("get", "/api/group-kpis/", {
    //     params: params,
    //     onSuccess,
    //     onFailure,
    //     isTokenRequired: false,
    //   });
    // },
    getPremiumGroups() {
      const successHandler = (res) => {
        this.premium_groups = res.data.premium_groups;
      };
      const failureHandler = () => {};
      let formData = {};
      // formData["detail_count"] = 5;
      Axios.request_GET(
        "/api/premium-groups",
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 768px) {
  .user-name {
    height: 167px !important;
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    width: 108px !important;
  }
  .user-name > div {
    font-size: 35px !important;
  }
  .user-image {
    height: 167px !important;
    width: 108px !important;
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }
  .sebi-ra-mobile {
    position: absolute;
    padding: 5px;
    font-family: Avenir;
    font-size: 9px;
    font-weight: 500;
    line-height: 5px;
    text-align: left;
    // height: 12px;
    border-radius: 4px;
    bottom: 8px;
    left: 55px;
    display: inline;
    border: 0.5px solid;
    background: linear-gradient(
      87.32deg,
      rgba(68, 105, 177, 0.8) 0%,
      rgba(111, 155, 239, 0.8) 100%
    );
    color: #fff;
    border-image-source: linear-gradient(180deg, #4469b1 0%, #1d2c4b 100%);
  }
  .details > div:nth-child(2) {
    font-family: Avenir;
    font-size: 9px !important;
    font-weight: 500;
    line-height: 13.66px;
    text-align: left;
    color: #333333b8;
  }
  .user-img-badge {
    height: 18px;
    width: 18px;
    margin-right: 0 !important;
  }
}
.user-name {
  background-color: #add8e6;
  color: #333333;
  width: 60px;
  height: 60px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.user-name > div {
  font-size: 22px;
}
.discount-price {
  font-family: Avenir;
  font-size: 12px;
  font-weight: 800;
  line-height: 15.03px;
  text-align: left;
  color: #333333;
}
.discount-percent {
  color: #27b568;
  font-family: Avenir;
  font-size: 10px;
  font-weight: 500;
  //   line-height: 12.29px;
  text-align: left;
}
.discount-strike {
  text-decoration: line-through;
  font-family: Avenir;
  font-size: 10px;
  font-weight: 500;
  //   line-height: 12.29px;
  text-align: left;
  color: #33333370;
}
.market-header {
  color: hsl(0deg 0% 0% / 87%);
  font-family: Avenir;
  font-size: 18px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
}
.header {
  font-family: Avenir;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.left-arrow {
  transform: rotate(-45deg);
}
.intru-txt {
  font-family: Avenir;
  font-size: 8px;
  font-weight: 500;
  line-height: 10.93px;
  text-align: left;
}
.group-header {
  font-family: Avenir;
  font-size: 14px;
  font-weight: 800;
  line-height: 19.12px;
  text-align: left;
  color: #333333;
}
.row > .col-md-4 {
  padding: 6px;
}
.group-subheader {
  font-family: Avenir;
  font-size: 12px;
  font-weight: 500;
  line-height: 13.66px;
  text-align: left;
  color: #33333399;
}
.subscribe {
  font-family: Avenir;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  line-height: 16.39px;
  text-align: center;
}
.sebi-ria {
  padding: 2.2px;
  font-family: Avenir;
  font-size: 9px;
  font-weight: 500;
  line-height: 12px;
  text-align: left;
  color: transparent;
  background: linear-gradient(180deg, #4469b1 0%, #1d2c4b 100%);
  border-radius: 4px;
  -webkit-background-clip: text;
  background-clip: text;
  border: 1.33px solid black;
}
.user-img-badge {
  width: 18px;
  height: 18px;
  margin-left: auto;
  margin-right: 10px;
  margin-top: 8px;
}
.user-badge {
  margin-top: 8px;
}
.user-abs {
  position: absolute;
  bottom: -25px;
  left: 10px;
}
.user-image {
  width: 60px;
  height: 60px;
  border-radius: 4px;
}
.title-txt {
  font-family: Avenir;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  line-height: 10.55px;
}
.details {
  text-align: center;
}
.details > div:first-child {
  font-family: Avenir;
  font-size: 13px;
  font-weight: 800;
  line-height: 17.76px;
  color: #333333;
}
.details > div:nth-child(2) {
  font-family: Avenir;
  font-size: 10px;
  font-weight: 500;
  line-height: 13.93px;
  text-align: left;
  color: #333333b8;
}
.br-radius {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.dashed-border {
  box-sizing: border-box;
  border-bottom: 2px dashed #e4e4e4;
}
.title {
  //   text-align: left;
  height: 17px;
  background: linear-gradient(
    102.19deg,
    #d2c081 0%,
    #feeeb6 53.13%,
    #d3bb65 100%
  );
}
</style>
